import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const usePaymentMethods = (params, options = {}) => {
  return useQuery(
    ["paymentMethodsReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getPaymentMethods(), {
        params,
      });
      const composeResponse = {
        clinics: res.data.data.clinics,
        reportData: res.data.data.report_data,
        total: res.data.data.total,
        balanceDue: res.data.data.balance_due,
      };
      return composeResponse;
    },
    options,
  );
};
